import React from "react";
import NearbyOrdersMaps from "./nearbyOrdersMaps";

const NearbyOrders = () => {
  return <NearbyOrdersMaps />;
};

export default NearbyOrders;
